var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.modules = pt.blocografico.modules || {};
pt.blocografico.modules.header = pt.blocografico.modules.header || {};
pt.blocografico.modules.header = (function () {
  function toogleMenu(button, pageLinksDiv) {
    if (button.className === "") {
      pageLinksDiv.className = button.className = "active";
      document.body.classList.add("no-scroll");
    } else {
      pageLinksDiv.className = button.className = "";
      document.body.classList.remove("no-scroll");
    }
  }

  function init(menu) {
    let menuButton = menu.querySelector(`#mobile-button`);
    let menuPages = menu.querySelector(`#navigation-menu-pages`);

    menuButton.addEventListener("click", () => {
      toogleMenu(menuButton, menuPages);
    });

    menuPages.addEventListener("click", () => {
      if (window.innerWidth <= 1201) {
        toogleMenu(menuButton, menuPages);
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 1201) {
        menuPages.className = menuButton.className = "";
        document.body.classList.remove("no-scroll");
      }
    });
  }

  return { init };
})();

document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector("#navigation-menu");
  if (menu) {
    pt.blocografico.modules.header.init(menu);
  }
});
